import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import FMPText from '../pureForm/FMPText';
import Transition from './Transition';
import FormComponent from "../FormComponent";
import async from "async";
import Zoom from "@material-ui/core/Zoom";
import CircularProgress from "@material-ui/core/CircularProgress";
import GasBuddyPricesContainer from '../../containers/reports/GasBuddyPrices';
import moment from 'moment';
import LockIcon from '@material-ui/icons/Lock';
import WarningIcon from '@material-ui/icons/Warning';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding : {
		padding : 10,
		[theme.breakpoints.up('md')]: {
			padding : '20px 50px 20px 50px',
		}
	},
	dialogPaper : {
		overflow: 'scroll',
		maxWidth : '100%',
		width: 800,
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin : 10,
	},
	submitButton : {
		fontSize : 16,
		borderRadius : '100px',
		padding : '15px 20px',
		textTransform: 'uppercase'
	},
	addInputButton : {
		borderRadius : '100px',
		marginTop : 20,
	},
	attachment :  {
		position : 'absolute',
		width:'100%',
		height : '100%',
		border : '1px solid #ddd'
	},
	emailBody : {
		border : '1px solid #ddd',
	},
	invoiceDocuments : {
		display: 'flex',
		flexWrap: 'wrap',
		alignContent: 'stretch',
		justifyContent: 'space-between',
		marginTop : 20,
	},
	invoicePage : {
		width : '33%',
		padding : 5,
		boxSizing : 'border-box',
	},
	invoicePageImg : {
		width : '100%',
		height : '100%',
		border : '1px solid #ddd',
	},
	pageSection : {
		borderBottom : '2px dashed #ccc',
		marginBottom : 30,
		paddingBottom : 30,
	},
	warningIcon : {
		marginTop : -9,
		width : 16,
		height : 16,
		position: 'relative',
		bottom: -3,
		marginRight: 3,
		color: '#b57809',
	},
});

class RetailPriceAddNote extends FormComponent {
	constructor (props) {
		super(props);
		this.state = {
			vendorBillId: undefined,
			additionalInvoiceEmails : [],
			formFieldError : {},
			emailNote : '',
			isSaving : false,
			savingStatus : undefined,
			isUpdate : false,
			savingSuccessful : false,
		};
	}

	componentDidUpdate(prevProps) {
		const { ignoredGasBuddyPrice, open} = this.props;

		//- Every time it opens figure out if its an update and update teh form
		if (!prevProps.open && open) {
			if (ignoredGasBuddyPrice) {
				const newState = this.fillForm();
				newState.isUpdate = true;
				this.setState(newState);
			}
		}
	}

	fillForm = () => {
		const {ignoredGasBuddyPrice } = this.props;
		if (!ignoredGasBuddyPrice) { return; }

		const newState = {};
		['note'].forEach(key => {
			if (_.isNil(ignoredGasBuddyPrice[key])) {
				return;
			}
			newState[key] = ignoredGasBuddyPrice[key];
		});
		return newState;
	};

	handleClose = () => {
		this.setState({
			isSaving: false,
			savingSuccessful: false,
			cost : '',
			description : '',
		}, this.props.onClose);
	};

	handleSave = () => {
		const {showErrors, updateGasBuddyPrice, ignoredGasBuddyPrice } = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({path, label}) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			showErrors(_.values(formFieldError));
			return;
		}

		const { lockedNote } = this.state;
		const { gasBuddyPriceId } = ignoredGasBuddyPrice;
		const params = {
			gasBuddyPriceId,
			lockedNote,
		};

		this.setState({
			isSaving: true,
		});

		async.waterfall([
			callback => {
				updateGasBuddyPrice({
					params,
					callback,
				});
			},
		], err => {
			if (err) {
				this.setState({
					isSaving: false,
				});
				return showErrors([err]);
			}

			_.delay(() => {
				this.setState({
					isSaving: false,
					savingSuccessful: true,
				});
			}, 500);
		});
	};

	render() {
		const {classes, open, ignoredGasBuddyPrice, recentGasBuddyPrice, fullScreen} = this.props;
		const { isSaving, savingSuccessful} = this.state;
		if (!ignoredGasBuddyPrice) { return null; }

		const ignoredPrice = ignoredGasBuddyPrice.gasBuddyPrice;
		const ignoredReportedDateTime = moment(ignoredGasBuddyPrice.reportedDateTime).format('M/D h:mm a');

		const recentPrice = recentGasBuddyPrice.gasBuddyPrice;
		const recentDateTime = moment(recentGasBuddyPrice.reportedDateTime).format('M/D h:mm a');

		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth='md'
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper}}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>
						Add Note to Locked Out Retail Price<br/>

					</DialogTitle>
					<DialogContent>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<div style={{fontSize: '120%', color:'#333', padding: 10}}>
									<LockIcon fontSize="small" /> Current FMP Price :
									<strong> {recentPrice}</strong> @ {recentDateTime}
								</div>
								<div style={{fontSize: '120%', color:'#333', padding : 10}}>
									<WarningIcon className={classes.warningIcon}/> Price Reported by GasBuddy/OPIS :
									<strong> {ignoredPrice}</strong> @ {ignoredReportedDateTime}
								</div>
							</Grid>
							<Grid item xs={12}>
								<Grid container spacing={2}>
									<FMPText
										{...this.setForm(`lockedNote`, 'Pricing Note', true)}
										multiline={3}
									/>
								</Grid>
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions style={{ display : 'flex', justifyContent : 'space-between'}}>
						<div>
							<Zoom
								in={isSaving}
								style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
								mountOnEnter unmountOnExit
							>
								<div className={classes.isSaving}>
									<CircularProgress style={{verticalAlign : 'middle'}} />
									<span style={{paddingLeft: 10}}>Saving...</span>
								</div>
							</Zoom>

							<Zoom
								in={savingSuccessful}
								style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
							>
								<div className={classes.savingSuccessful}>
									<div className={classes.greenCheckedIcon}/>
									<span style={{paddingLeft: 10}}>Save Successful. </span>
									<Button onClick={this.handleClose}>
										Close
									</Button>
								</div>
							</Zoom>
						</div>

						<div>
							<Button onClick={this.handleClose}>
								Cancel
							</Button>
							<Button
								disabled={isSaving}
								variant="contained"
								onClick={this.handleSave}
								className={classes.submitButton}
								color="primary"
							>
								Save Cost
							</Button>
						</div>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

RetailPriceAddNote.propTypes = {
	ignoredGasBuddyPrice : PropTypes.object,
	recentGasBuddyPrice : PropTypes.object,
	updateGasBuddyPrice : PropTypes.func.isRequired,

	classes: PropTypes.object.isRequired,
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	fullScreen: PropTypes.bool.isRequired,
	showErrors : PropTypes.func,
	history : PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
	GasBuddyPricesContainer,
])(RetailPriceAddNote);
